import React from "react";
import { TColor, TTypographyVariant } from "../../types";
import Typography from "./Typography";

type TProps = {
    translatedLabel: string | React.ReactNode;
    value: string | null;
    keySize?: TTypographyVariant;
    keyColor?: TColor;
    keyStyles?: React.CSSProperties;
    valueSize?: TTypographyVariant;
    valueColor?: TColor;
    valueStyles?: React.CSSProperties;
};

const KeyValue = ({
    translatedLabel,
    keySize = "label-regular-regular",
    keyColor = "text-primary-700",
    keyStyles,
    value,
    valueSize = "label-regular-medium",
    valueColor = "text-primary-900",
    valueStyles = { paddingLeft: "5px", display: "inline" }
}: TProps) => (
    <Typography variant={keySize} color={keyColor} styles={keyStyles}>
        {translatedLabel}:
        <Typography variant={valueSize} color={valueColor} styles={valueStyles}>
            {value}
        </Typography>
    </Typography>
);

export default KeyValue;
